import * as React from 'react';
export var OtherLink = function (_a) {
    var detail = _a.detail, children = _a.children;
    return (<div data-testid={detail.type}>
		{children}
		<p>
			Detail správního řízení{' '}
			<a href={detail.url} target='_blank'>
				MAM
			</a>
		</p>
	</div>);
};
